<template>
  <div class="footer-main">
    <div class="footer-top">
      <div class="footer-left">
        <ul>
          <li>メニュー</li>
<!--          <li> <a href="https://www.jp-night.me/contact/index.html" target="_blank">お問い合わせ</a> </li>-->
          <li> <a href="http://www.jp-night.com/#company" target="_blank">企業情報</a> </li>
        </ul>
        <ul>
          <li> Follow Us</li>
          <li><img src="../../../../assets/image/icon_footer_ins.png" alt=""> <span class="footer-left-text"> <a target="_blank" href="https://www.instagram.com/jpnight/">Instagram</a> </span> </li>
          <li><img src="../../../../assets/image/icon_footer_twi.png" alt=""> <span class="footer-left-text"> <a target="_blank" href="https://twitter.com/jpnight2018">Twitter</a>  </span> </li>
        </ul>
      </div>
      <div class="footer-right">
        <img src="../../../../assets/image/logo_jpn.png" alt="">
      </div>
    </div>
    <div class="footer-bottom"><img src="../../../../assets/image/icon_company.png" alt=""> <span>{{ year }} JP NIGHT.</span> </div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: ''
    };
  },
  created() {
    let date = new Date();
    this.year = date.getFullYear()
  }
};
</script>

<style lang="scss" scoped>
@import "./css/pc.css";
@import "./css/ipad.css";
@import "./css/phone.css";
</style>
